// @ts-nocheck

import { KLCollectibleStatuses } from '../../types/collectible';
import { selectKLUserPoleBet, selectKLUserPoleBets, selectKLUserPoleBetStatus, selectKLUserPoleBetTime } from '../user';

const { createSelector } = require('reselect');

const getKLPoleChipIndexFromProps = (_, { index }: { index: number }) => index;

const selectFirstPendingPostNotifiedChipIndex = createSelector([selectKLUserPoleBets], (bets) => {
  const foundIndex = bets
    .filter((k) => k)
    .findIndex((currentBet, i) => {
      const nextBet = bets[i + 1];
      return currentBet?.notified && nextBet && !nextBet.notified && nextBet.status === KLCollectibleStatuses.PENDING;
    });

  return foundIndex !== -1 ? foundIndex + 1 : -1;
});

const selectKLPoleBetNotified = createSelector(
  [getKLPoleChipIndexFromProps, selectKLUserPoleBet, selectFirstPendingPostNotifiedChipIndex],
  (index, bet, firstPendingPostNotifiedChipIndex) =>
    index === firstPendingPostNotifiedChipIndex ? true : bet?.notified,
);

const selectKLPoleChipProps = createSelector(
  [getKLPoleChipIndexFromProps, selectKLUserPoleBetStatus, selectKLPoleBetNotified, selectKLUserPoleBetTime],
  (index, status, notified, time) => ({
    index,
    status,
    notified,
    time,
  }),
);

export default selectKLPoleChipProps;
